// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VtIKb6Apikw8hh3AvYsn{align-items:center;display:flex}.AVp1lqwbtJUbCRz0666k{color:var(--content-primary-primary-inverted);font-size:13px;font-weight:400}.AVp1lqwbtJUbCRz0666k .Ol67gb0dr0QUsm6eZsQd{color:var(--content-primary-primary-inverted);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `VtIKb6Apikw8hh3AvYsn`,
	"label": `AVp1lqwbtJUbCRz0666k`,
	"domain": `Ol67gb0dr0QUsm6eZsQd`
};
export default ___CSS_LOADER_EXPORT___;
